import React from "react";
import { Typography } from "antd";

export const SubTitle = React.memo<{ text: string }>(
  ({ text }) => <Typography.Title level={5} className="mt-4">{text}</Typography.Title>
);
